// Session-persistent Firefly assist mode (PA-1a).
//
// Per docs/planning/personal_assistant_mode_plan.md §3.2 — clears on
// browser refresh (sessionStorage only).

export type AssistMode = "default" | "personal_assistant";

export const PA_ASSIST_MODE_STORAGE_KEY = "bb-pa-assist-mode";

type Listener = (next: AssistMode) => void;
const listeners = new Set<Listener>();

function parseAssistMode(raw: string | null): AssistMode {
  return raw === "personal_assistant" ? "personal_assistant" : "default";
}

function readStoredAssistMode(): AssistMode {
  if (typeof sessionStorage === "undefined") return "default";
  try {
    return parseAssistMode(sessionStorage.getItem(PA_ASSIST_MODE_STORAGE_KEY));
  } catch {
    return "default";
  }
}

function writeStoredAssistMode(next: AssistMode): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(PA_ASSIST_MODE_STORAGE_KEY, next);
  } catch {
    // Private mode / quota — in-tab state still updates via listeners.
  }
}

export function getAssistMode(): AssistMode {
  return readStoredAssistMode();
}

export function setAssistMode(next: AssistMode): void {
  writeStoredAssistMode(next);
  for (const listener of listeners) listener(next);
}

export function subscribeAssistMode(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
